import { takeLatest, put, call } from 'redux-saga/effects';

import { listPlanejamento } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_PLANEJAMENTO,
  NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_PENDING,
  NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_PLANEJAMENTO } from '@commons/consts';

function* sagaNewFilterNextPagePlanejamento(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const idSafraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva?.id ?? -1;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    let list = yield call(listPlanejamento, idFazenda, idSafraAtiva, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);    

    sessionStorage.setItem(CONST_FILTER_PLANEJAMENTO, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_PLANEJAMENTO_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPagePlanejamento() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PLANEJAMENTO, sagaNewFilterNextPagePlanejamento)
}